"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
require("./ToggleChip.scss");
var _classnames = _interopRequireDefault(require("../../../utils/classnames"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var ToggleChip = function ToggleChip(_ref) {
  var id = _ref.id,
    label = _ref.label,
    active = _ref.active,
    toggle = _ref.toggle,
    disabled = _ref.disabled,
    tabIndex = _ref.tabIndex;
  var classes = (0, _classnames["default"])({
    active: active,
    disabled: disabled
  });
  return /*#__PURE__*/_react["default"].createElement("button", {
    id: id,
    className: 'uin-toggle-chip ' + classes,
    onClick: toggle,
    tabIndex: tabIndex
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "uin-chip-icon"
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "gcl-icon sent"
  })), /*#__PURE__*/_react["default"].createElement("span", {
    className: "uin-chip-label"
  }, label));
};
ToggleChip.propTypes = {
  label: _propTypes["default"].string.isRequired,
  active: _propTypes["default"].bool,
  toggle: _propTypes["default"].func.isRequired,
  disabled: _propTypes["default"].bool
};
var _default = exports["default"] = ToggleChip;


//////////////////
// WEBPACK FOOTER
// ./~/cw-unified-inbox/dist/components/common/ToggleChip/ToggleChip.js
// module id = 1436
// module chunks = 0